export default __webpack_public_path__ + "static/media/Iconvirus3.114ccb32.svg";